import type { IconNode } from '../types';

/**
 * @name flower-pot
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNOSA4aDEiIC8+CiAgPHBhdGggZD0iTTEyIDV2MSIgLz4KICA8cGF0aCBkPSJNMTUgOGgtMSIgLz4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjgiIHI9IjIiIC8+CiAgPHBhdGggZD0iTTEyIDExYTMgMyAwIDEgMS0zLTMgMyAzIDAgMSAxIDMtMyAzIDMgMCAxIDEgMyAzIDMgMyAwIDEgMS0zIDMiIC8+CiAgPHBhdGggZD0iTTEyIDEwdjgiIC8+CiAgPHBhdGggZD0ibTE1IDE4LTEgNGgtNGwtMS00IiAvPgogIDxwYXRoIGQ9Ik04IDE4aDgiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/flower-pot
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const flowerPot: IconNode = [
  ['path', { d: 'M9 8h1', key: 'zb2d67' }],
  ['path', { d: 'M12 5v1', key: 'cx5see' }],
  ['path', { d: 'M15 8h-1', key: 'n9w4hr' }],
  ['circle', { cx: '12', cy: '8', r: '2', key: '1822b1' }],
  ['path', { d: 'M12 11a3 3 0 1 1-3-3 3 3 0 1 1 3-3 3 3 0 1 1 3 3 3 3 0 1 1-3 3', key: 'pk6c1h' }],
  ['path', { d: 'M12 10v8', key: '3jqxej' }],
  ['path', { d: 'm15 18-1 4h-4l-1-4', key: '1w7y47' }],
  ['path', { d: 'M8 18h8', key: '1no2b1' }],
];

export default flowerPot;
